import React from "react";
import Footer from "../../components/Footer/Footer";
import NewHeader from "../../components/NewHeader/NewHeader";
import { connect } from "react-redux";

//css files
import "react-responsive-modal/styles.css";
import "./FailedPayment.css";

export const FailedPayment = (props) => {
  return (
    <>
      <NewHeader />

      <div className="container">
        <div className="subContainer">
          <div className="tkImg">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/ce3ebc59-af24-48d5-a896-491bd1ddd492.png"
              alt="oops Image"
              className="oopsImg"
            />
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/0f7ecec5-c62a-45bd-b248-7d7ce8204ff7.jpg"
              alt="Payment Failed Image"
              className="failedImg"
            />
          </div>
          <div className="tkDes">
            <div className="tkDes_msg">
              <p>"Oh no, Your Payment Failed!"</p>
              <p>Please try after sometime!</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FailedPayment);
